import { get, post, put, destroy } from './config';

const Analytics = {
    getMonthlyOrderIndicators: (startDate, endDate) =>
        get(`/v1/analytics/monthly-order-indicators?startDate=${startDate}&endDate=${endDate}`),
    getAverageOrderIndicators: (startDate, endDate) =>
        get(`/v1/analytics/average-order-indicators?startDate=${startDate}&endDate=${endDate}`),
    compareOrderPriceIndicators: (startDate) =>
        get(`/v1/analytics/monthly-compare-order-price-indicators?startDate=${startDate}`)
}

export default Analytics;
